// extracted by mini-css-extract-plugin
export var light_bulb = "light_bulb-mod--light_bulb--2LIs5";
export var small = "light_bulb-mod--small--3X1ry";
export var medium = "light_bulb-mod--medium--2t7Hz";
export var large = "light_bulb-mod--large--2nhbx";